import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AddResource from "./create-picnote/AddResource";
import ViewPicnote from "./ViewPicnote";
import MasonryCom from "./MasonryCom";
import NoData from "./NoData";
import { myFeed, singleFeed } from "../redux/picnote";

function PicnotesCards() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const openNoteId = searchParams.get("openNote");

  // stable userInfo check
  const userInfo = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userInfo"));
    } catch (e) {
      return null;
    }
  }, []);

  const { myFeedsData } = useSelector((state) => state.picnote) || { myFeedsData: [] };

  useEffect(() => {
    setLoading(true);
    dispatch(myFeed()).finally(() => setLoading(false));
  }, [dispatch]);

  // If openNoteId exists, try to open it: find in feed or fetch single
  useEffect(() => {
    if (!openNoteId) return;

    const list = myFeedsData?.myFeeds || [];
    const found = list.find((n) => String(n.noteId) === String(openNoteId));

    const openFromData = (noteObj) => {
      // ensure we pass a consistent shape { note: ... }
      setSelectedNote({ note: noteObj });
      setDialogOpen(true);
    };

    if (found) {
      openFromData(found);
      return;
    }

    // Not found in feed — fetch singleFeed (app route expects AddResource)
    const fetchSingle = async () => {
      try {
        const resp = await dispatch(singleFeed(openNoteId));
        if (resp && resp.status === 200 && resp.data) {
          // Keep shape consistent with other components: { note: ... }
          openFromData({ note: resp.data.message || resp.data });
        }
      } catch (err) {
        console.error("Error fetching single feed note:", err);
      }
    };

    fetchSingle();
  }, [openNoteId, myFeedsData, dispatch]);

  const closeAddSource = () => {
    setDialogOpen(false);
    setSelectedNote(null);
    const params = new URLSearchParams(location.search);
    if (params.has("openNote")) {
      params.delete("openNote");
      navigate({ search: params.toString() }, { replace: true });
    }
  };

  return (
    <>
      {dialogOpen && selectedNote ? (
        userInfo ? (
          <AddResource
            closeAddSource={closeAddSource}
            picnoteCardsdata={selectedNote}
            picnoteResponseWhileAddingNote={selectedNote}
            AllNotesForRelated={myFeedsData?.myFeeds}
            isDialogOpen={dialogOpen}
          />
        ) : (
          <ViewPicnote
            closeAddSource={closeAddSource}
            picnoteCardsdata={selectedNote}
            AllNotesForRelated={myFeedsData?.myFeeds}
            isDialogOpen={dialogOpen}
          />
        )
      ) : null}

      {loading ? (
        "Loading Data..."
      ) : myFeedsData?.myFeeds?.length > 0 ? (
        <MasonryCom
          picnotes={myFeedsData?.myFeeds}
          column={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }}
          cardsWidth={"1200px"}
          TabName={"myFeed"}
        />
      ) : (
        <NoData TabTitle={"myFeeds"} />
      )}
    </>
  );
}

export default PicnotesCards;
